export default __webpack_public_path__ + "static/media/03.8194462d.png";